import { render } from "./WhatsAppButton.vue?vue&type=template&id=58aea320&scoped=true"
import script from "./WhatsAppButton.vue?vue&type=script&lang=js"
export * from "./WhatsAppButton.vue?vue&type=script&lang=js"

import "./WhatsAppButton.vue?vue&type=style&index=0&id=58aea320&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58aea320"]])

export default __exports__